import type { MyPageConfig } from '../../@types/context/my-page-config.types';

export const myPageOffersConfig: Pick<MyPageConfig['options'], 'offers'> = {
  offers: {
    isExpandedVariant: true,
    // MV-1881: combo loan display is global — every market shows the detailed
    // combo loan card + explainer.
    // MV-3201: top-up display is global too — the tag and the explainer must
    // read the same in every country. Other loan-type tags stay filtered out.
    hasLoanType: true,
    // MV-3341: 'Combo Loan Zero Cash' is the refinance-consumes-the-top-up
    // combo — a type missing from this list renders a bare card.
    // MV-3390: 'Combo Loan Topup' is the combo-as-top-up (NOBA case 2b).
    enabledLoanTypes: [
      'Combo Loan',
      'Combo Loan Detailed',
      'Combo Loan Zero Cash',
      'Combo Loan Topup',
      'Topup Loan',
    ],
    hasDocumentationInfo: false,
    hasInsuranceUpsell: true,
  },
};
